import styled from 'styled-components';
import Select from 'products/nomad_insurance/components/Select';
import { th } from 'style/theme';
import { P } from 'components/Typography';

export const MapContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 24px 0;
`;

export const Reminder = styled(P)`
  text-align: right;
  font-weight: 700;
  font-size: 14px;
  color: ${th('colors.red')};
`;

export const DestinationList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
`;

export const CountrySelect = styled(Select)`
  margin-top: 24px;
`;

export const TooltipContent = styled.div`
  font-size: 16px;
  max-width: 200px;
  padding: 6px 0;
`;
